<template>
  <div id="calendar-month-full">
    <div class="month-full">
      <div class="full-width month-full-header">
        <div class="days-of-week" v-for="(day, val) in days_of_week" :key="val">{{$t(day) | minDayOfWeek}}</div>
      </div>
      <div class="full-width month-full-row" v-for="week in weeks" :key="week.id">
        <div  v-for="(dateOfWeek, index) in week"  
          :key="index"
          :class="'days-of-month ' + (dateOfWeek.format('MM') == full_date.format('MM') ? '' : 'text-disable ')
               + (dateOfWeek.format('YYYY-MM-DD') == $moment(full_date).format('YYYY-MM-DD') ? ' choosed_date' : '') " 
          @click="setFullDate(dateOfWeek)">

          <div v-if="dateOfWeek != null"
                :class="'text-center selected-date '
                + (dateOfWeek.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'border-radius-50per' : '')"
                :style="dateOfWeek.format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') && today ? 'background: ' + todayColor + '; color: #fff;' : ''"
          >
            {{dateOfWeek.format('D')}}
          </div>
          <div v-for="(value, i) in dates[$moment(dateOfWeek).format('YYYYMMDD')].data" :key="i.label">
            <div v-for="(item) in value" :key="item.id"
                  v-if="dates[$moment(dateOfWeek).format('YYYYMMDD')] != null && item.type != null"
                  :class="'event '
                + (dates[$moment(dateOfWeek).subtract(1, 'day').format('YYYYMMDD')] == null || dates[$moment(dateOfWeek).subtract(1, 'day').format('YYYYMMDD')][item.type] == null ? ' non--before ' : '')
                + (dates[$moment(dateOfWeek).add(1, 'day').format('YYYYMMDD')] == null || dates[$moment(dateOfWeek).add(1, 'day').format('YYYYMMDD')][item.type] == null ? ' non--after ' : '')"
                  :style="'background: ' + (title[item.type].color)"
            >
              <span v-if="(i == 3 || i == 4)" v-for="data in dates[$moment(dateOfWeek).format('YYYYMMDD')][item.type]">
                {{$t('calendar.' + item.type)}}
              </span>
              <span v-if="i != 3 && i != 4 && d.opening == item.value.opening" v-for="d in dates[$moment(dateOfWeek).format('YYYYMMDD')][item.type]">
                <span v-if="d.name != '' && d.name != null">{{d.name}}</span>
                <span v-else>{{$t('calendar.' + item.type)}}</span>
                ({{d.opening | minTime}} - {{d.closing | minTime}})
              </span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .month-full-header {
    display: flex;
    height: 50px;
    border-bottom: 1px solid #e3e4e9 !important;
  }
  .days-of-week {
    flex: 1;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    padding-bottom: 10px;
    color: #0091ff;
    height: 50px;
    line-height: 50px;
  }
  .month-full-row {
    display: flex;
  }
  .month-full-row .days-of-month:first-child {
    border-left: 1px solid #e3e4e9 !important;
  }
  .days-of-month {
    flex: 1;
    text-align: center;
    font-size: 12px;
    padding-top: 0px;
    padding-bottom: 10px;
    font-weight: 600;
    cursor: pointer;
    min-height: 100px;
    border-bottom: 1px solid #e3e4e9 !important;
    border-right: 1px solid #e3e4e9 !important;
  }
  .text-disable {
    color: #c2c4c6;
  }
  .border-radius-50per {
    border-radius: 50%;
  }
  .bg-main {
    background: #0091ff;
    color: #fff !important;
  }
  .selected-date {
    padding: 2px 0px;
    max-width: 100%;
    width: 22px;
    margin-left: auto;
    margin-right: auto;
  }
  .event {
    width: 100%;
    height: 15px;
    margin-top: 3px;
    margin-bottom: 3px;
    text-align: left;
    padding-left: 5px;
    padding-right: 5px;
    color: #fff;
    font-size: 10px;
    /*white-space: pre-line;*/
    overflow: hidden;
  }
  .event.non-before {
    width: calc(100% - 5px);
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    margin-left: 5px;
  }
  .event.non-after {
    width: calc(100% - 5px);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    margin-right: 5px;
  }
  .event.non-before.non-after {
    width: calc(100% - 10px);
  }
  .choosed_date {
    background-color: #d1d4d7;
  }
</style>
<script>
export default {
  name: 'CalendarMonthFull',
  props: {
    events: {
      type: Array,
      required: false
    },
    full_date: {
      required: false
    },
    today: {
      default: false
    },
    todayColor: {
      default: '#0091ff'
    },
    data: {
      type: Object,
      required: false
    },
    title: {
      required: false
    }
  },
  data: function () {
    return {
      dates: {},
      weeks: [],
      days_of_week: {
        '0': 'common.sun',
        '1': 'common.mon',
        '2': 'common.tue',
        '3': 'common.wed',
        '4': 'common.thu',
        '5': 'common.fri',
        '6': 'common.sat'
      }
    }
  },
  methods: {
    createDateByMonth () {
      this.dates = {}
      let date = this.$moment(this.full_date)
      let startDayOfWeek = parseInt(date.startOf('month').format('e'))
      let dates = []
      let week = 0
      for (let i = 0; i < startDayOfWeek; i++) {
        let d = this.$moment(date.startOf('month')).subtract(startDayOfWeek - i, 'day')
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
        if (this.dates[d.format('YYYYMMDD')] == null) {
          this.dates[d.format('YYYYMMDD')] = {}
        }
      }

      for (let i = date.startOf('month').format('D'); i <= date.endOf('month').format('D'); i++) {
        let d = this.$moment(date.startOf('month')).add(i - 1, 'day')
        week = Math.floor((parseInt(d.format('D')) + startDayOfWeek - 1) / 7)
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
        if (this.dates[d.format('YYYYMMDD')] == null) {
          this.dates[d.format('YYYYMMDD')] = {}
        }
      }

      let endDayOfWeek = parseInt(date.endOf('month').format('e'))
      for (let i = endDayOfWeek + 1; i <= 6; i++) {
        let d = this.$moment(date.endOf('month')).add(i - endDayOfWeek, 'day')
        if (dates[week] == null) {
          dates[week] = []
        }
        dates[week].push(d)
        if (this.dates[d.format('YYYYMMDD')] == null) {
          this.dates[d.format('YYYYMMDD')] = {}
        }
      }

      for (let i in this.data) {
        let items = this.data[i]
        for (let j in items) {
          let item = items[j]
          let d = null
          // Hard code for hut's day checking, need to improve
          if (typeof item == 'string') {
            d = this.$moment(item, 'YYYY-MM-DD')
          } else {
            d = this.$moment(item.date, 'YYYY-MM-DD')
          }

          if (this.dates[d.format('YYYYMMDD')] != null) {
            if (this.dates[d.format('YYYYMMDD')][i] == null) {
              this.dates[d.format('YYYYMMDD')][i] = []
            }
            this.dates[d.format('YYYYMMDD')][i].push(item)
          }
        }
      }

      for (let d in this.dates) {
        let item = {}
        let types = []
        for (let t in this.dates[d]) {
          types.push(t)
          switch (t) {
            case 'huts_day':
              item[3] = [{
                type: t,
                value: this.dates[d][t]
              }]
              break
            case 'public_holiday':
              item[4] = [{
                type: t,
                value: this.dates[d][t]
              }]
              break
            default:
              for (let i in this.dates[d][t]) {
                let key = this.$moment.duration(this.dates[d][t][i].opening).asSeconds()
                if (item[key] == null) {
                  item[key] = []
                }
                item[key].push({
                  type: t,
                  value: this.dates[d][t][i]
                })
              }
          }
        }

        this.dates[d].data = item
        this.dates[d].types = types
      }

      return dates
    },
    setFullDate (date) {
      this.$emit('setFullDate', date)
      let newData = {}
      for (let i in this.dates[date.format('YYYYMMDD')]) {
        if (i != 'data' && i != 'types') {
          newData[i] = this.dates[date.format('YYYYMMDD')][i]
        }
      }
      this.$emit('dataChange', newData)
    }
  },
  filters: {
    minDayOfWeek: function (day) {
      return day.substr(0, 3).toUpperCase()
    },
    minTime: function (time) {
      return time.substr(0, 5).toUpperCase()
    }
  },
  created () {
    this.weeks = this.createDateByMonth()
    this.setFullDate(this.$moment(this.full_date))
  },
  watch: {
    full_date: function (val) {
      this.weeks = this.createDateByMonth()
    },
    data: {
      handler: function (after, before) {
        this.weeks = this.createDateByMonth()
        let newData = {}
        for (let i in this.dates[this.full_date.format('YYYYMMDD')]) {
          if (i != 'data' && i != 'types') {
            newData[i] = this.dates[this.full_date.format('YYYYMMDD')][i]
          }
        }
        this.$emit('dataChange', newData)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/CalendarMonthFull.vue